import StepThree from "@/components/dashboard/pay/StepThree";

const PayStep3 = () => <StepThree />;

export default PayStep3;
